import { render, staticRenderFns } from "./RecordingUpload.vue?vue&type=template&id=6ef9816a"
import script from "./RecordingUpload.vue?vue&type=script&lang=js"
export * from "./RecordingUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports